"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cautano": {
    "6c8d3e2a": [{
      "hkey": "396097f1",
      "slug": "cautano",
      "name": "Cautano",
      "primary": true,
      "skipSearch": false
    }],
    "cacciano": [{
      "hkey": "396097f1",
      "slug": "cautano",
      "name": "Cautano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f61e3d6e": [{
      "hkey": "396097f1",
      "slug": "cautano",
      "name": "Cautano",
      "primary": true,
      "skipSearch": false
    }],
    "cesine": [{
      "hkey": "396097f1",
      "slug": "cautano",
      "name": "Cautano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "681bb7d2": [{
      "hkey": "396097f1",
      "slug": "cautano",
      "name": "Cautano",
      "primary": true,
      "skipSearch": false
    }],
    "loreto": [{
      "hkey": "396097f1",
      "slug": "cautano",
      "name": "Cautano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ca175d64": [{
      "hkey": "396097f1",
      "slug": "cautano",
      "name": "Cautano",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "396097f1",
      "slug": "cautano",
      "name": "Cautano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;